import Vue from 'vue';

// Lightweight cross component event bus.
// Currently used only to let the footer "Cookie settings" link reopen the
// cookie banner. Kept tiny and dependency free on purpose.
export const eventBus = new Vue();

export default eventBus;
